<div class="topline">
    <h1>Clients</h1>

    <app-inlinemessage level="warning" *ngIf="noPartner && !isClientAdministrator" message="No Partner Brand Set for Client"></app-inlinemessage>

    <div class="clientarea">
        <ng-container *ngIf="!isClientAdministrator">
        <mat-menu #menu="matMenu">
            <ng-template matMenuContent let-item="item">
                <button mat-menu-item (click)="editCompany()">Edit</button>
                <button
                    mat-menu-item
                    (click)="togglePayrollTeamPlusDefault()"
                    [matTooltip]="plusPlanDefaultHelpText">
                    {{ getPayrollTeamPlusDefaultActionLabel() }}
                </button>
                <button
                    mat-menu-item
                    (click)="toggleIncludedPlusPlan()"
                    [matTooltip]="includedPlusPlanHelpText">
                    {{ getIncludedPlusPlanActionLabel() }}
                </button>
            </ng-template>
        </mat-menu>

        <mat-icon [matMenuTriggerFor]="menu">settings</mat-icon>
        </ng-container>

        <mat-form-field *ngIf="clients.length > 0">
            <mat-label>Current Client</mat-label>

            <mat-select
                    [(value)]="selectedClientId"
                    (selectionChange)="setClientId($event.value)">
                <mat-option *ngFor="let client of clients" [value]="client.id">
                    {{ client.name }} ({{ clientCensusCounts[client.id] || 0 }})
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <h1 *ngIf="clients?.length === 0">
        {{ clientName }}
    </h1>
</div>

<app-infoband [items]="info"></app-infoband>

<nav mat-tab-nav-bar [tabPanel]="tabs">
    <a
            mat-tab-link
            *ngFor="let link of links"
            (click)="gotoTab(link)"
            [active]="activeLink?.title === link.title">
        {{ link.title }}
    </a>
</nav>

<ng-container *ngIf="!selectedClientId">
    <app-inlinemessage
            level="info"
            message="Please select a client so that you can manage their census, eligibility, and enrollment">
    </app-inlinemessage>
</ng-container>

<ng-container *ngIf="selectedClientId">
    <app-client-census
            *ngIf="activeLink?.title === 'Census'"
            [clientAdministrator]="isClientAdministrator"
            [clientId]="selectedClientId">
    </app-client-census>

    <app-client-eligibility
            *ngIf="activeLink?.title === 'Eligibility'"
            [clientAdministrator]="isClientAdministrator"
            [clientId]="selectedClientId">
    </app-client-eligibility>

    <app-client-enrollment
            *ngIf="activeLink?.title === 'Enrollment'"
            [clientId]="selectedClientId">
    </app-client-enrollment>
</ng-container>

<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
